import React from 'react';

const NotificationIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="#F2F8FD" />
      <path
        d="M28.19 22.0598L27.06 20.1798C26.81 19.7698 26.59 18.9798 26.59 18.4998V16.6298C26.59 12.9998 23.64 10.0498 20.02 10.0498C16.39 10.0598 13.44 12.9998 13.44 16.6298V18.4898C13.44 18.9698 13.22 19.7598 12.98 20.1698L11.85 22.0498C11.42 22.7798 11.32 23.6098 11.59 24.3298C11.86 25.0598 12.47 25.6398 13.27 25.8998C14.35 26.2598 15.44 26.5198 16.55 26.7098C16.66 26.7298 16.77 26.7398 16.88 26.7598C17.02 26.7798 17.17 26.7998 17.32 26.8198C17.58 26.8598 17.84 26.8898 18.11 26.9098C18.74 26.9698 19.38 26.9998 20.02 26.9998C20.65 26.9998 21.28 26.9698 21.9 26.9098C22.13 26.8898 22.36 26.8698 22.58 26.8398C22.76 26.8198 22.94 26.7998 23.12 26.7698C23.23 26.7598 23.34 26.7398 23.45 26.7198C24.57 26.5398 25.68 26.2598 26.76 25.8998C27.53 25.6398 28.12 25.0598 28.4 24.3198C28.68 23.5698 28.6 22.7498 28.19 22.0598ZM20.75 17.9998C20.75 18.4198 20.41 18.7598 19.99 18.7598C19.57 18.7598 19.23 18.4198 19.23 17.9998V14.8998C19.23 14.4798 19.57 14.1398 19.99 14.1398C20.41 14.1398 20.75 14.4798 20.75 14.8998V17.9998Z"
        fill="#333333"
      />
      <path
        d="M22.8301 28.01C22.4101 29.17 21.3001 30 20.0001 30C19.2101 30 18.4301 29.68 17.8801 29.11C17.5601 28.81 17.3201 28.41 17.1801 28C17.3101 28.02 17.4401 28.03 17.5801 28.05C17.8101 28.08 18.0501 28.11 18.2901 28.13C18.8601 28.18 19.4401 28.21 20.0201 28.21C20.5901 28.21 21.1601 28.18 21.7201 28.13C21.9301 28.11 22.1401 28.1 22.3401 28.07C22.5001 28.05 22.6601 28.03 22.8301 28.01Z"
        fill="#333333"
      />
    </svg>
  );
};

export default NotificationIcon;
